import { findIndex, isString, isEmpty, includes } from 'lodash';

// retourne la locale courante de l'url si non trouvée ou invalide alors locale par defaut
export function getLocaleFromRoutes(pathname, locales, defaultLocale) {
    // For Plebicard case, we use hostname to choose language, not route.
    const locale = getLocaleFromLocation(defaultLocale);
    return locale && _isLocaleReconnue(locale, locales, defaultLocale) ? locale : defaultLocale;
}

export function getLocaleFromLocation(defaultLocale) {
    const i18nHostnames = process.env.REACT_APP_DOMAIN_i18n_HOSTS.split(',');
    const i18nLocales = process.env.REACT_APP_DOMAIN_i18n_LOCALES.split(',');

    const hostnameIndex = findIndex(i18nHostnames, function(o) {
        return o === window.location.host;
    });
    if (hostnameIndex < 0) {
        return defaultLocale;
    }

    return i18nLocales[hostnameIndex];
}

/**
 * retourne true si 'locale' est une string et si elle correspond à une entrée dans le tableau locales ou à la locale par défaut
 * Lance un exception si locales et defaultLocale sont vide ou undefined
 * @param {String} locale
 * @param {Array} locales
 * @param {String} defaultLocale
 */
export function _isLocaleReconnue(locale, locales, defaultLocale) {
    if (!locales && locales === undefined && !defaultLocale && defaultLocale === undefined) {
        throw new Error(
            '[_isLocaleReconnue] : Au moins un de ces deux paramètres [locales, defaultLocale] doit être défini.',
            'features/i18n/utils.js',
            25
        );
    }
    if (isString(locale)) {
        if (isEmpty(locales)) {
            return locale === defaultLocale;
        } else {
            return includes(locales, locale);
        }
    } else {
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/services/i18n/utils.js